import { useEffect } from "react";
import NProgress from "nprogress";
const LazyLoad = () => {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return "";
};

export default LazyLoad;
